import { EVENT } from '../seo/pages';

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

/**
 * The calendar date after an ISO one, without routing it through a timezone.
 *
 * A calendar date has no time and no zone. Building a local Date and formatting
 * it back moves the day for half the world, which is exactly the bug
 * SecretsOverflow's own toIsoDate was written to stop, so the arithmetic is
 * done in UTC from end to end.
 */
function nextDay(iso: string): string {
  const d = new Date(`${iso}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + 1);
  return d.toISOString().slice(0, 10);
}

/**
 * A SecretsOverflow search already filled in for the night of the celebration.
 *
 * Their /book page reads checkIn, checkOut and guests off the query string,
 * prefills the stay form, and when both dates are there runs the search on
 * load instead of making the visitor press the button. It takes ISO calendar
 * dates as they come, and its own date defaults are written not to overwrite
 * anything the query string supplied. So this lands a guest on real rooms and
 * real prices for the right night rather than on an empty form.
 *
 * `guests` is deliberately left off: their page defaults to two and has a
 * stepper, and this site has no idea how many people are in the car.
 *
 * Anything other than a clean ISO date falls back to their front page, which
 * lists the same hotels.
 */
export function overflowBookingUrl(checkIn: string | null | undefined): string {
  if (!checkIn || !ISO_DATE.test(checkIn)) return EVENT.overflowUrl;
  const url = new URL('book', EVENT.overflowUrl);
  url.searchParams.set('checkIn', checkIn);
  url.searchParams.set('checkOut', nextDay(checkIn));
  return url.toString();
}
